import React, { useCallback } from 'react';
import { PageLayout } from '../../Layout/PageLayout';
import { CompanyInfoForm } from './CompanyInfoForm';
import { useApi } from '../../../hooks';
import { companyService } from '../../../services';

export const CompanyInfoPage: React.FC = () => {
  const handleLoadError = useCallback((err: unknown) => {
    console.error('Failed to load company info:', err);
  }, []);

  const { data: company, error, refetch } = useApi({
    apiCall: companyService.getCompany,
    onError: handleLoadError,
  });

  const handleSuccess = useCallback(() => {
    void refetch();
  }, [refetch]);

  return (
    <PageLayout
      fluid
      title="Company Information"
      breadcrumbs={[
        { text: 'Settings', href: '/settings' },
        { text: 'Company Information' },
      ]}
      alert={error ? { variant: 'danger', message: error } : undefined}
    >
      <CompanyInfoForm company={company || undefined} onSuccess={handleSuccess} />
    </PageLayout>
  );
}; 
